import { Helmet } from "react-helmet-async";

export function HomeStructuredData() {
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Simplifyte",
    url: "https://www.simplifyte.com",
    logo: "https://www.simplifyte.com/preview.jpg",
    description:
      "Simplifyte is workflow management software for CA firms, tax consultants, advocates, consultants and professional service teams in India.",
    email: "support@simplifyte.com",
    foundingLocation: "India",
    sameAs: [],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "support@simplifyte.com",
      availableLanguage: ["English", "Hindi"],
    },
  };

  const softwareApp = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Simplifyte",
    url: "https://www.simplifyte.com",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    description:
      "Simplifyte is workflow management software for CA firms, tax consultants, advocates, consultants and professional service teams. It helps teams manage client-wise work, FY and period tracking, documents, deadlines, review notes, approvals, reminders, audit trail and closure proof in one structured workspace — reducing workflow chaos caused by WhatsApp, email, Excel, Drive and verbal follow-ups.",
    offers: {
      "@type": "Offer",
      priceCurrency: "INR",
      price: "0",
      description: "Free plan available. Paid plans for professional teams.",
    },
    audience: {
      "@type": "Audience",
      audienceType:
        "CA firms, tax consultants, advocates, consultants and professional service teams",
    },
    featureList: [
      "Client-wise work tracking",
      "FY and period-based workflow tracking",
      "Document collection and pending tracking",
      "Review and approval workflow",
      "Deadline reminders",
      "Audit trail",
      "Closure proof",
      "Task assignment and staff handover",
      "Partner visibility and approvals",
    ],
    screenshot: "https://www.simplifyte.com/preview.jpg",
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Simplifyte",
    url: "https://www.simplifyte.com",
    description:
      "Workflow management software for CA firms and professional service teams in India.",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://www.simplifyte.com/docs?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organization)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(softwareApp)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(website)}
      </script>
    </Helmet>
  );
}

export function SolutionPageStructuredData({ name, description, url }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name,
    description,
    url,
    isPartOf: {
      "@type": "WebSite",
      name: "Simplifyte",
      url: "https://www.simplifyte.com",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.simplifyte.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Solutions",
          item: "https://www.simplifyte.com/solutions",
        },
        {
          "@type": "ListItem",
          position: 3,
          name,
          item: url,
        },
      ],
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export function FeaturePageStructuredData({ name, description, url }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name,
    description,
    url,
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.simplifyte.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Features",
          item: "https://www.simplifyte.com/features",
        },
        {
          "@type": "ListItem",
          position: 3,
          name,
          item: url,
        },
      ],
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
